import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createMultiLevelApproval,
  deleteMultiLevelApproval,
  fetchUserGeoMapping,
  updateMultiLevelApproval,
} from "../../../services/multiLevelApprovalService";

export const createMultiLevelApprovalThunk = createAsyncThunk(
  "approvalFlow/createMultiLevel",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createMultiLevelApproval(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const updateMultiLevelApprovalThunk = createAsyncThunk(
  "approvalFlow/updateMultiLevel",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateMultiLevelApproval(id, data);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const deleteMultiLevelApprovalThunk = createAsyncThunk(
  "approvalFlow/deleteMultiLevel",
  async (id, { rejectWithValue }) => {
    try {
      await deleteMultiLevelApproval(id);
      return id; // Return the deleted ID to update the slice
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// Fetch user geo mapping by user ID
export const fetchUserGeoMappingThunk = createAsyncThunk(
  "user/fetchUserGeoMapping",
  async (userId, { rejectWithValue }) => {
    try {
      return await fetchUserGeoMapping(userId);
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
